// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

import { define } from '@nvidia-elements/core/internal';
import { Menu, MenuGroup, MenuItem } from '@nvidia-elements/core/menu';

define(Menu);
define(MenuGroup);
define(MenuItem);

declare global {
  interface HTMLElementTagNameMap {
    'nve-menu': Menu;
    'nve-menu-group': MenuGroup;
    'nve-menu-item': MenuItem;
  }
}
